import { UtilityService } from '@eforall/common';
import { GridColumn, buildColumn } from '@eforall/dashboard';
import { Engagement } from '../../../../../interfaces';
import { AppService, DomainDataService } from '../../../../../services';

export function getColumns(util: UtilityService, app: AppService, domainDataService: DomainDataService) {
	const columns: GridColumn<Engagement, unknown>[] = [
		buildColumn(util, 'Id', row => row.lastContactStaffId, { header: 'LastEngagedByStaffId', hidden: true }),
		buildColumn(util, 'FullName', row => app.getStaffNameById(row.lastContactStaffId), { header: 'Last Contacted By', width: 80 }),
		buildColumn(util, 'Date', row => util.date.fromUTC(row.lastContactUTC), { header: 'Last Contact Date', width: 70 }),
		buildColumn(util, 'FullName', row => row.person.fullName, { header: 'Name' }),
		buildColumn(util, 'Date', row => util.date.fromUTC(row.engagementDateUTC), { header: 'Initial Engagement Date' }),
		buildColumn(util, 'Text', row => domainDataService.data().engagementPurposesMap[row.purposeId]?.name, { header: 'Purpose' }),
		buildColumn(util, 'Text', row => row.activity, { header: 'Activity' }),
	];
	return columns;
}